import React from "react";
import { FaWhatsapp, FaEnvelope, FaPhone } from "react-icons/fa";
import logo from "../assets/logo.svg";
import logoGvm from "../assets/logo-gvm.png";

// 🔹 Pulsante riutilizzabile arrotondato
function RoundedButton({ icon: Icon, text, bgColor, onClick }) {
  const [hovered, setHovered] = React.useState(false);

  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "14px 26px",
    fontSize: "16px",
    cursor: "pointer",
    borderRadius: "50px",
    border: "none",
    color: "white",
    backgroundColor: bgColor,
    boxShadow: hovered
      ? "0 6px 10px rgba(0,0,0,0.18)"
      : "0 4px 6px rgba(0,0,0,0.12)",
    transform: hovered ? "scale(1.05)" : "scale(1)",
    transition: "all 0.2s ease",
    minWidth: "260px"
  };

  return (
    <button
      style={style}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {Icon && <Icon size={22} />}
      {text}
    </button>
  );
}

// ✅ EXPORT SOLO QUI, A LIVELLO ROOT
export default function Home({ setPagina }) {

  const handleWhatsApp = () => {
    window.open("https://wa.me/393383395427", "_blank");
  };

  const handleEmail = () => {
    window.location.href = "mailto:info@medicajato.it";
  };

  const handleCall = () => {
    window.location.href = "tel:+393383395427";
  };

  const handleCup = () => {
    setPagina("cup");
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "40px 20px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "720px",
        margin: "0 auto"
      }}
    >
      {/* LOGO MEDICAJATO */}
      <img
        src={logo}
        alt="Medicajato Center"
        style={{ width: "200px", marginBottom: "20px" }}
      />

      <h1>Medicajato Center</h1>
      <p style={{ color: "#555" }}>
        Centro di Prevenzione Educazione Santitaria Assistenza Infermieristica<p>
          </p> GVM Poit e GVM CUP decentrato MEH
      </p>

      {/* SEZIONE CUP */}
      <div
        style={{
          marginTop: "50px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <img
          src={logoGvm}
          alt="GVM Care & Research"
          style={{ width: "160px", marginBottom: "10px" }}
        />

        <RoundedButton
          text="🏥 CUP Maria Eleonora Hospital"
          bgColor="#8b0000"
          onClick={handleCup}
        />
      </div>

      {/* CONTATTI */}
      <h3 style={{ marginTop: "45px" }}>Contatti diretti</h3>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          alignItems: "center"
        }}
      >
        <RoundedButton
          icon={FaWhatsapp}
          text="WhatsApp"
          bgColor="#25D366"
          onClick={handleWhatsApp}
        />
        <RoundedButton
          icon={FaPhone}
          text="Chiama"
          bgColor="#007bff"
          onClick={handleCall}
        />
        <RoundedButton
          icon={FaEnvelope}
          text="Email"
          bgColor="#6c757d"
          onClick={handleEmail}
        />
      </div>

      {/* PRIVACY */}
      <p style={{ marginTop: "30px", fontSize: "14px" }}>
        <a
          href="https://www.medicajato.it/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Informativa Privacy
        </a>
      </p>
    </div>
  );
}
